import React from "react";
import "./progressbar.scss";

const Progressbar = ({
  completed,
  color,
  height = "10px",
  animation = 300,
  onClick = () => {},
}) => {
  const containerStyles = {
    height: height,
    borderRadius: height,
  };

  const fillerStyles = {
    width: `${completed}%`,
    backgroundColor: color,
    borderRadius: height,
    transition: `width ${animation}ms ease-in-out`,
  };

  return (
    <div
      className="progressbar-container"
      style={containerStyles}
      onClick={onClick}
    >
      <div className="progressbar-progress" style={fillerStyles}></div>
    </div>
  );
};

export default Progressbar;
